export const environment = {
  production: true,
  apiUrl: "https://comprehensive-backed-dev.azurewebsites.net/api/",
  apiUrlForTPL: "https://qaapi.saiyarti.com/api/",
  apiUrlForRateCard: "https://qaapi.saiyarti.com/api/",
  apiKey: "a",
  apiPassword: "b",
  sURL: "https://qacomprehensive.saiyarti.com/payment-success",
  fURL: "https://qacomprehensive.saiyarti.com/payment-failure",
  storageAccount: "saiyartidev",
  cdnUrl: "https://saiyartidev.blob.core.windows.net",
  tplRCImageContainer: "rc-book",
  tplCivilCardImageContainer: "civil-card",
  rcImageContainer: "comprehensive-rc-book",
  companyImageContainer: "company",
  civilCardImageContainer: "comprehensive-civilcard-book",
  carImageContainer: "comprehensive-car-book",
  policyImageContainer: "comprehensive-policy-book",
  tradeLicenseImageContainer: "comprehensive-inurancecompany-book",
  companyLogoContainer: "comprehensive-inurancecompany-logo",
  amplitudekey: "223c1264e8ca65a3f0d6000dad41ee34",
  dynamicLink: "https://saiyartidev.page.link",
  dynamicLinkOfl: "https://qaportal.saiyarti.com/",
  firebase: {
    apiKey: "AIzaSyCwTM4nDDcnToYmHTtNnf3I16zfr8PoSs4",
    authDomain: "saiyarti-dev.firebaseapp.com",
    databaseURL: "https://saiyarti-dev.firebaseio.com",
    projectId: "saiyarti-dev",
    storageBucket: "saiyarti-dev.appspot.com",
    messagingSenderId: "73985020764",
    appId: "1:73985020764:web:e9f6eb1123d8ffe30da799",
    measurementId: "G-YYQELWJ86D",
  },
  paymetGateway: {
    url: "https://sandbox.hesabe.com",
    accessCode: "c333729b-d060-4b74-a49d-7686a8353481",
    secret: "PkW64zMe5NVdrlPVNnjo2Jy9nOb7v1Xg",
    ivKey: "5NVdrlPVNnjo2Jy9",
    merchantCode: "842217",
  },
  ablyKey: "p9Q9LQ.jhMtUA:6PhZHiV9-Tn6Sdb_CnO1faCee8IzAsxzxuv8IQ8JSto",
};
